import { useCallback, useContext, useMemo } from 'react';
import { FunnelMapCanvasInternalCtx } from '../FunnelMapCanvasInternalCtx';
import { UseEventHandlerReturn } from './types';
import { NodeEntityTypes, OnNodeClickProps } from '../../sweep-canvas/canvas-types';

export const useMetadataElementEventHandler = (): UseEventHandlerReturn => {
  const { onMetadataClick } = useContext(FunnelMapCanvasInternalCtx);

  const onNodeClick = useCallback(
    (props: OnNodeClickProps) => {
      const type = props.entity.type;
      if (type === NodeEntityTypes.StandaloneMore || type === NodeEntityTypes.Standalone) {
        onMetadataClick?.({
          event: props.event,
          fullMetadataId: props.id,
          entity: type === NodeEntityTypes.StandaloneMore ? 'more-button' : 'node',
        });
      }
    },
    [onMetadataClick],
  );

  const returnFunctions = useMemo(() => ({ onNodeClick }), [onNodeClick]);

  return returnFunctions;
};
